export enum Qiniu {
  UPLOAD_TYPE_USER = 1,
  UPLOAD_TYPE_TROUBLE = 2,
  UPLOAD_TYPE_FINISH = 3,
  UPLOAD_TYPE_COMPANY = 4,
  UPLOAD_TYPE_BBS = 5,
  UPLOAD_TYPE_BRAND = 11,
  UPLOAD_TYPE_PRODUCT = 12,
  UPLOAD_TYPE_MODEL = 13,
  UPLOAD_TYPE_DEVICE = 14,
  UPLOAD_TYPE_PARTS = 15,
  UPLOAD_TYPE_FAULT = 16,
  UPLOAD_TYPE_OAPI = 21,
  UPLOAD_TYPE_CHECK = 30,
  UPLOAD_TYPE_APK = 41,
  UPLOAD_TYPE_OTHER = 99,
  UPLOAD_TYPE_PROJECT = 61,
  UPLOAD_TYPE_KNOWLEDGE = 65
}
